// utils/auth.js
export const useAuth = () => {
  const TOKEN_KEY = 'auth_token'
  const LOGIN_STATUS_KEY = 'user_login_status'

  // 设置登录状态
  const setLogin = (token) => {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(LOGIN_STATUS_KEY, 'logged_in')
  }

  // 退出登录
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.setItem(LOGIN_STATUS_KEY, 'logged_out')
    // 清除所有相关数据
    // const keysToRemove = ['user_info', 'permissions', 'refresh_token']
    // keysToRemove.forEach(key => localStorage.removeItem(key))
  }

  // 获取登录状态
  const isLoggedIn = () => {
    return localStorage.getItem(LOGIN_STATUS_KEY) === 'logged_in' &&
      localStorage.getItem(TOKEN_KEY)
  }

  return { setLogin, logout, isLoggedIn }
}